import { InternetProduct, isOptionActive } from '@dch/products-business-logic';

export const gigaPackSpeed = ['PILMO', 'DHJSM', 'KLBLN', 'CXTVA', 'CGDOS'];

export function getInternetProductDescription(
  selectedProduct: InternetProduct,
) {
  const description =
    selectedProduct?.options?.length > 0 &&
    selectedProduct.options.find(
      (option) =>
        gigaPackSpeed.includes(option.optionCodeForDescription) &&
        isOptionActive(option),
    )?.name;
  return description ? description + ' | ' : '';
}
